<div class="card-preview {{ [2,3,4].includes(card.status) ? 'active' : '' }} ">

  <div class="card-type">Typ karty: {{ getCardTypeLabel($safeNavigationMigration(card?.person)) }}</div>
  <div class="card-header">


    <div class="card-querycode">

      <qr-code [value]="'' + card.code" [size]="100" [errorCorrectionLevel]="'M'" />
    </div>
  </div>

  <div class="card-number">{{ (card.nr + '').padStart(10, '0') }}</div>

  @if (card.person?.complementary?.length > 3) {
    <div class="card-person">Karty powiązane: {{ card.person.complementary }}</div>
  }

  <div class="card-person">
    <span class="card-label">Imię i nazwisko:</span>
    <span class="card-value">{{ card.person.name }} {{ card.person.surname }}</span>
  </div>
  <div class="card-valid">
    <span class="card-label">Ważna do:</span>
    <span class="card-value">{{ isEndless() ? 'karta ważna bezterminowo' : (card.valid | date:'yyyy-MM-dd') }}</span>
  </div>
</div>
<div class="card-status" [ngClass]="cardStatusOptions[card.status]">
  utworzono: {{card.created | date: 'yyyy-MM-dd HH:mm'}} zmiana: {{card.updated | date: 'yyyy-MM-dd HH:mm'}} status: {{ cardStatusOptions[card.status] }}
</div>
